import { 
    CreateTransportTypeDto, 
    DeleteTransportTypeDto,
    EditTransportTypeDto,
    GetTransportTypeDto, 
    MessageResponseDto, 
    UtilityTransportTypeApiFp,
    UtilTransportTypeControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTransportTypeModel = UtilTransportTypeControllerGet200Response;
export type GetTransportTypeModel = GetTransportTypeDto;
export type MutateResponseTransportTypeModel = MessageResponseDto;
export type CreateTransportTypeModel = CreateTransportTypeDto;
export type UpdateTransportTypeModel = EditTransportTypeDto;
export type DeleteTransportTypeModel = DeleteTransportTypeDto;

export const apiTransportTypeFp =  UtilityTransportTypeApiFp(apiConfig);
export const getTransportTypeController = apiTransportTypeFp.utilTransportTypeControllerGet;
export const createTransportTypeController = apiTransportTypeFp.utilTransportTypeControllerCreate;
export const updateTransportTypeController = apiTransportTypeFp.utilTransportTypeControllerEdit;
export const deleteTransportTypeController = apiTransportTypeFp.utilTransportTypeControllerDelete;

export const QueryKeyTransportType = QueryKey.TransportType;